var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-know ft-16",class:{ dark: _vm.dark },on:{"click":_vm.btnClick}},[_vm._v(_vm._s(_vm.$t('btn1')))])}
var staticRenderFns = []

export { render, staticRenderFns }